import React from "react";
import { Flex, Box } from "@rebass/grid";
import styled from "styled-components";

import Icon, { Icons } from "components/Icon";

interface SideMenuItemProps {
  children: React.ReactNode;
  icon?: Icons.IconDefinition;
  route?: string;
  depth: number;
  active: boolean;
}

function SideMenuItem({
  children,
  icon,
  route = "",
  depth,
  active,
}: SideMenuItemProps) {
  const menuIcon = icon ? (
    <Icon icon={icon} color="#fff" verticalCenter size="lg" fixedWidth />
  ) : null;
  const content = children ? (
    <Flex>
      <Box>{menuIcon}</Box>
      <Box>
        <ChildrenContainer>{children}</ChildrenContainer>
      </Box>
    </Flex>
  ) : (
    menuIcon
  );

  return (
    <Container depth={depth} active={active}>
      <MockLink>
        <>{content}</>
      </MockLink>
    </Container>
  );
}

const Container = styled.div<{ depth: number; active: boolean }>`
  font-size: 14px;
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 600;
  position: relative;
  left: ${(props: any) => (props.active && props.depth === 1 ? `-6px` : "0")};
`;

const ChildrenContainer = styled.div`
  padding-left: 16px;
  max-width: 180px;

  overflow: hidden;
  text-overflow: ellipsis;
`;

const MockLink = styled.div`
  padding: 10px 15px;
`;

export default SideMenuItem;
